
export const CONSTANTS = {
  IMAGE: {
    WIDTH: 161.48,
    HEIGHT: 282.2,
    RADIUS: 19.73
  }
}